import { useState } from "react";
import { CargarClienteComponent, ClientesListado, Header } from "../../components";
import { ROLES } from "../../constants/roles";
import { useAuthContext } from "../../context/auth";
import "./stylesClienteGestion.scss";

export const CargarCliente = () => {
  const [mostrarCargarCliente, setMostrarCargarCliente] = useState(false);
  const { rol } = useAuthContext();
  const puedeEditar = rol !== ROLES.INVERSOR;

  const toggleCargarCliente = () => {
    setMostrarCargarCliente(!mostrarCargarCliente);
  };

  return (
    <div className="clientes-gestion">
      <Header>
        {puedeEditar && (
          <button
            onClick={toggleCargarCliente}
            className={`boton-agregar-cliente ${mostrarCargarCliente ? "cancelar" : "agregar"}`}
          >
            {mostrarCargarCliente ? "Cancelar" : "Agregar Cliente"}
          </button>
        )}
      </Header>
      {mostrarCargarCliente && <CargarClienteComponent />}
      <ClientesListado />
    </div>
  );
};
